import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getHomeData } from "features/home/homeSlice";
import ProductReel from "features/ProductReel";
import ServicesBarDesktop from "components/ServicesBarDesktop";
import { Desktop, DesktopDown, device } from "theme/Breakpoints";
import ServicesBar from "components/ServicesBar";
import VideoPlayer from "features/VideoPlayer/VideoPlayer";
import { setBreadcrumbTitle } from "features/breadcrumb/breadcrumbSlice";
import Partners from "components/Partners/Partners";
import Subscribe from "components/Subscribe";
import ProductCategories from "components/ProductCategories";
import styled from "styled-components";

const Home = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getHomeData());
    dispatch(setBreadcrumbTitle(""));
  }, [dispatch]);

  return (
    <>
      {/* <MessageContainer>
        <HomeMessage className="text-body">
          Уважаеми клиенти, в следващите няколко седмици поетапно актуализираме
          цените на всички артикули на нашия сайт. Относно наличности и актуални
          цени може да се свържите с нас на някой от посочените телефони.
        </HomeMessage>
      </MessageContainer> */}
      <DesktopDown>
        <ServicesBar />
        <Partners />
        <ProductReel />
        <ProductCategories />
        <VideoPlayer />
        <Subscribe />
      </DesktopDown>

      <Desktop>
        <ServicesBarDesktop />
        <ProductReel />
        <Partners />
        <ProductCategories />
        <VideoPlayer />
        <Subscribe />
      </Desktop>
    </>
  );
};
export default Home;

const MessageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;

  @media only screen and (${device.tablet}) {
    height: 200px;
  }

  @media only screen and (${device.laptop}) {
    height: 150px;
  }
`;

const HomeMessage = styled.h1`
  margin: 0;
  padding: 0;
  width: 90%;
  text-align: center;

  @media only screen and (${device.tablet}) {
    width: 75%;
  }
  @media only screen and (${device.laptop}) {
    width: 65%;
  }
`;
